import React , { useContext } from 'react' ;

const Homee = () => {
    return(
        <div className="homee" >
            <h1> Home Page </h1>
        </div>
    );
}

export default Homee ;